import React from 'react'

import { Page, PageLoader } from '@/components'
import { useParams } from 'react-router-dom'
import { ErrorPage404 } from '@/pages/ErrorPage404/ErrorPage404'

import BrandDetailsPageContent from './BrandDetailsContent'
import useBrand from '@/query/brands/useBrand'

export const BrandDetails = () => {
  const { brandPath = '' } = useParams()
  const { brand, isError, isLoading } = useBrand({ brandPath })

  if (isError) {
    return <ErrorPage404 />
  }

  if (isLoading || !brand) {
    return (
      <Page>
        <PageLoader />
      </Page>
    )
  }

  return <BrandDetailsPageContent brand={brand} />
}
